export default __webpack_public_path__ + "static/media/arrow-icon.542d779c.svg";